import { JobStatus } from '@funnellab/shared/src/types/directus-enums';
import { type LoaderFunction, redirect } from 'react-router-dom';
import { Paths, generateJobWizardUrl } from '@src/paths.ts';
import jobService from '@src/api/services/JobService.ts';
import type { JobDetails } from '@src/api/queries/job';

export const jobsDetailsViewLoader = (async ({
  params,
}): Promise<JobDetails | Response> => {
  const jobId = params.jobId;
  if (!jobId) {
    return redirect(Paths.JOBS);
  }

  const job = await jobService.getJobForDetailView(jobId);

  if (job.status === JobStatus.DRAFT) {
    // redirect the user to the job wizard if the job is a draft
    return redirect(generateJobWizardUrl(jobId));
  } else if (job.status === JobStatus.REACTIVATING) {
    return redirect(generateJobWizardUrl(jobId) + '?step=1');
  }

  return job;
}) satisfies LoaderFunction;
